export default "__VITE_ASSET__91f646a0__"